import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { useIntl } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import WidgetCard from "../../widget/card";
import "../style.css";

const WidgetAsk = ({ isDoubleBox, numberItems }) => {
  const [filteredSurveys, setFilteredSurveys] = useState([]);
  const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);
  const surveys = useSelector((state) => state.ask.surveys);
  const navigate = useNavigate();

  const list = surveys.list;
  const isGettingSurveys = surveys.isGettingSurveys;
  const toFill = surveys.toFill;
  const toReadAccountant = surveys.toReadAccountant;
  const toRead = surveys.toRead;
  const myType = main.myType;

  useEffect(() => {
    if (surveys?.list.length === 0) return;

    setFilteredSurveys(
      surveys.list.filter((e) => {
        return e.createdAt;
      })
    );
  }, [surveys?.list]);

  const getItemDescription = (itemId) => {
    let itemDescription = "";
    company?.companies?.map((item) => {
      if (itemId === item?.uuid) {
        itemDescription = item.ragioneSociale;
      }
      return null;
    });
    return itemDescription;
  };

  const renderFooter = () => {
    return (
      <div style={{ textAlign: isDoubleBox ? "right" : "center" }}>
        <div>
          <Button kind={"secondary"} onClick={() => navigate("/ask-list")} colorScheme={"ghost"}>
            <FormattedMessage id="ask.widget.showAll" />
          </Button>
        </div>
      </div>
    );
  };

  const getStudioDescription = (itemId, managerId) => {
    const myCompany = company?.companies?.find((comp) => itemId === comp.uuid);
    const accountantList = myCompany?.commercialistiList;
    const myStudio = accountantList?.find((acc) => managerId === acc.uuid);
    const studioDescription = myStudio?.ragioneSociale;
    return studioDescription;
  };

  const renderRowAsk = (currentSurvey, count, isLast) => {
    let dateFormatted = "";
    if (currentSurvey.createdAt) {
      dateFormatted = moment(currentSurvey.createdAt).format("DD MMM YYYY");
    }
    return (
      <div
        key={"rowAsk_" + dateFormatted + count}
        className={`containerFlex rowSurvey${!currentSurvey.managerViewedAt && currentSurvey.completedAt ? " unread" : ""}`}
        style={{
          padding: "12px",
          borderBottom: !isLast ? "1px solid #C1C1C4" : "none",
        }}
      >
        <div className="firstRow">
          {myType === "STUDIO" ? (
            <div>{getItemDescription(currentSurvey.itemId)}</div>
          ) : (
            <div>{getStudioDescription(currentSurvey.itemId, currentSurvey.managerId)}</div>
          )}
          <div>
            {myType === "STUDIO" ? (
              <FontAwesomeIcon
                icon={[!currentSurvey.managerViewedAt && currentSurvey.completedAt ? "fas" : "far", "circle"]}
                style={{ fontSize: 8, color: "#0090d1" }}
              />
            ) : (
              <FontAwesomeIcon
                icon={[!currentSurvey.itemViewedAt && currentSurvey.completedAt ? "fas" : "far", "circle"]}
                style={{ fontSize: 8, color: "#0090d1" }}
              />
            )}
          </div>
        </div>
        <div className="secondRow">
          <div>{currentSurvey.title}</div>
          <div>{dateFormatted}</div>
        </div>
      </div>
    );
  };

  const renderTitle = () => {
    const notEmptySurveys = filteredSurveys && filteredSurveys.length > 0;

    let labelToFill = "";
    let labelToRead = "";

    if (toFill > 0) {
      labelToFill = `${useIntl().formatMessage({
        id: "ask.widget.toFill",
      })} (${toFill})`;
    }

    if (myType === "STUDIO") {
      if (toReadAccountant > 0) {
        labelToRead = `${useIntl().formatMessage({
          id: "ask.widget.toRead",
        })} (${toReadAccountant})`;
      }
    } else {
      if (toRead > 0) {
        labelToRead = `${useIntl().formatMessage({
          id: "ask.widget.toRead",
        })} (${toRead})`;
      }
    }

    return (
      <div
        style={{
          borderBottom: notEmptySurveys ? "none" : "1px solid #f2f5f8",
          paddingBottom: notEmptySurveys ? "initial" : 8,
        }}
      >
        <div style={{ width: "50%", display: "inline-block", marginTop: 13 }}>
          <FormattedMessage id="ask.widget.title" />
        </div>
        {notEmptySurveys && (
          <div className="widgetAsk-statistics">
            {labelToFill} &nbsp;&nbsp; {labelToRead}
          </div>
        )}
      </div>
    );
  };

  const renderContentSurveys = () => {
    filteredSurveys.sort((a, b) => moment(b["createdAt"]) - moment(a["createdAt"]));

    let arrayFirstCol = [];
    let arraySecondCol = []; // questa è valorizzata solo nel caso di box doppio = isDoubleBox a true
    if ((!filteredSurveys || filteredSurveys.length === 0) && !isGettingSurveys)
      arrayFirstCol.push(
        <div
          key="noSurveys"
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {myType === "STUDIO" && (
            <>
              <div className="TS-button-circle" onClick={() => navigate("/ask-edit")}>
                <FontAwesomeIcon icon={["far", "plus"]} style={{ fontSize: "23px", color: "white", margin: "0 auto" }} />
              </div>
              <div style={{ fontSize: 18, color: "#005075", paddingTop: 16 }}>
                <FormattedMessage id="ask.tooltips.addNewAsk" />
              </div>
            </>
          )}
          <div
            style={{
              fontSize: 16,
              color: "#9da6ad",
              paddingTop: 16,
              width: 288,
              textAlign: "center",
            }}
          >
            <FormattedMessage id="ask.widget.emptyWidget" />
          </div>
        </div>
      );
    else {
      /** ciclo la lista delle deadlines nello stato redux per il numero di items richiesto dal parent */
      for (let count = 0; count < numberItems; count++) {
        /** TODO separare in da pagare e da riscuotere. Secondo ux se non ci sono da riscuotere resta tutto
         * da pagare. Tenere in considerazione questo. Si potrebbero fare 2 chiamate in componentDidMount
         * uno per i da pagare e uno da riscuotere e poi unire in subjective tramite reducer.
         * Per ora chiamo la solita lista
         * se doubleBox è true allora divido su 2 colonne e popolo prima arrayFirstCol e dopo arraySecondCol
         * altrimenti solo arrayFirstCol
         */
        let currentSurvey = filteredSurveys[count];
        /** potrei avere il caso che chiedo es 8 elementi e me ne ritornano 4 perchè a db non abbiamo
         * 8 scadenze la if gestisce il caso, senza andrebbe in errore
         * */
        if (currentSurvey) {
          let renderRow = renderRowAsk(currentSurvey, count, count === numberItems - 1);
          if (isDoubleBox && count >= numberItems / 2) {
            arraySecondCol.push(renderRow);
          } else {
            arrayFirstCol.push(renderRow);
          }
        }
      }
    }

    return (
      <div className="containerFlex" style={{ height: "100%" }}>
        <div className={isDoubleBox ? "columnFlex50 withMargin" : "columnFlex100"}>{arrayFirstCol}</div>
        {isDoubleBox ? <div className="columnFlex50">{arraySecondCol}</div> : null}
      </div>
    );
  };

  return (
    <WidgetCard
      type={isDoubleBox && !isGettingSurveys ? "box2_3" : "box1_3"}
      titleWidget={renderTitle()}
      footer={list && list.length > 0 && renderFooter()}
      isCentered={!list || isGettingSurveys || (list && list.length === 0)}
    >
      {!isGettingSurveys ? renderContentSurveys() : <FontAwesomeIcon icon={["far", "circle-notch"]} spin style={{ color: "#0090d1" }} />}
    </WidgetCard>
  );
};

export default WidgetAsk;
